import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRetouch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRetouch"><Path d="M18 2L18.9334 4.06662L21 5L18.9334 5.93338L18 8L17.0666 5.93338L15 5L17.0666 4.06662L18 2Z" stroke="currentColor"/><Path d="M17.5 10.5H6.5V15C6.5 18.0376 8.96243 20.5 12 20.5C15.0376 20.5 17.5 18.0376 17.5 15V10.5Z" stroke="currentColor"/><Path d="M2.5 21V12C2.5 6.75329 6.75329 2.5 12 2.5C12.3377 2.5 12.6714 2.51762 13 2.552M21.5 21V12C21.5 10.9333 21.3242 9.90772 21 8.95056" stroke="currentColor"/></CentralIconBase>;
});

export default IconRetouch;
